"use strict";

exports.__esModule = true;
exports.getDefaultDispatchType = getDefaultDispatchType;
exports.hasAnyDeliverableItems = hasAnyDeliverableItems;

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _Status = _interopRequireDefault(require("@wix/wixrest-utils/dist/openrest-helpers/Status"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDefaultDispatchType({
  restaurant,
  dispatchTime,
  displayableMenu
}) {
  const dispatchTypes = restaurant.deliveryInfos.filter(di => isDispatchInfoActive(di, (0, _momentTimezone.default)(dispatchTime).tz(restaurant.timezone))).map(di => di.type);
  const uniqueDispatchTypes = Array.from(new Set(dispatchTypes));
  const foundDeliverableItems = hasAnyDeliverableItems(displayableMenu);
  const isDeliverySupported = foundDeliverableItems && uniqueDispatchTypes.includes('delivery');

  if (uniqueDispatchTypes.length === 0) {
    throw new Error('getDefaultDispatchType: No dispatch type found');
  } else if (uniqueDispatchTypes.length === 1) {
    return uniqueDispatchTypes[0];
  } else if (isDeliverySupported) {
    return 'delivery';
  } else {
    return 'takeout';
  }
}

function hasAnyDeliverableItems(displayableMenu) {
  return displayableMenu.map(_menu => _menu.sections.map(section => section.items.length > 0).some(Boolean)).some(Boolean);
}

function isDispatchInfoActive(dispatchInfo, dispatchTime) {
  const _StatusHelper$getStat = _Status.default.getStatus(dispatchInfo.availability, dispatchTime),
        status = _StatusHelper$getStat.status,
        reason = _StatusHelper$getStat.reason;

  const isClosed = status === 'unavailable' && reason === 'closed';
  return dispatchInfo.inactive !== false && !isClosed;
}
//# sourceMappingURL=dispatchTypeLogic.js.map